window.MathJax = {
    tex: {
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"]
      ], // ⾏内公式选择符
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"],
      ], // 段内公式选择符
    },
    options: {
      // 隐藏右键菜单
      enableMenu: false,
      // processHtmlClass权重最高
       // 避开某些标签
      skipHtmlTags: [
        "script",
        "noscript",
        "style",
        "textarea",
        "pre",
        "code",
        "a"
      ],
      // 如果需要只渲染mathjax-demo中的元素而忽略其他元素，则给body或最外层元素添加类名mathjax-ign。
      ignoreHtmlClass: "mathjax-ign",
      processHtmlClass: "mathjax-demo",
     
    },
    startup: {
      // mathjax内容初始化过程
      ready: function () {
        MathJax.startup.defaultReady();
      },
      // 在mathjax就绪后立刻对整个文档进行公式字符串的替换
      // pageReady:function(){
      //     return MathJax.startup.defaultPageReady().then(() => {
      //     console.log('MathJax initial typesetting complete');
      //   });
      // }
    },
  };